// src/components/quotes/TicketClassificationFields.jsx
//
// Issue Type + Sub-Issue Type, as two selects — THE classification control,
// shared by the quote push modal and the onboarding tickets modal. It takes
// the picklists as PROPS (see useTicketPicklists) so a modal with many
// tickets fetches once, never per instance.
//
// Sub-Issue Type is a CHILD of Issue Type: it lists only the chosen parent's
// children, is disabled until a parent is chosen, and `onChange` CLEARS it
// whenever the parent changes — a stale child from the previous parent is a
// mismatched pair, and the backend would drop it anyway. Inactive values are
// already filtered by the hook. ⚠ DEGRADE, DON'T BLOCK: `error` renders a
// quiet note and no selects; the surrounding action stays available.
import React from "react";
import { subIssuesFor } from "./ticketPicklists";

export default function TicketClassificationFields({
  picklists, error, issueType, subIssueType, onChange, disabled, idPrefix = "ticket", unavailableTestId = "classification-unavailable",
}) {
  if (error) {
    return (
      <div data-testid={unavailableTestId} style={{ fontSize: 10, color: "var(--text3)", marginBottom: 10, lineHeight: 1.5 }}>
        Issue type and sub-issue type are unavailable right now (the Autotask picklists did not load). The ticket can still be created and classified in Autotask afterwards.
      </div>
    );
  }
  const subOptions = subIssuesFor(picklists, issueType);
  const selectStyle = { fontSize: 12, marginBottom: 0 };
  return (
    <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <label htmlFor={`${idPrefix}-issue-type`} style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", display: "block" }}>
          Issue type <span style={{ fontWeight: 400, color: "var(--text3)" }}>(optional)</span>
        </label>
        <select id={`${idPrefix}-issue-type`} className="inp" aria-label="Issue type" value={issueType ?? ""} style={selectStyle}
                disabled={!!disabled || !picklists}
                onChange={(e) => onChange({ issueType: e.target.value, subIssueType: "" })}>
          <option value="">{picklists ? "— None —" : "Loading…"}</option>
          {(picklists ? picklists.issueTypes : []).map((v) => <option key={v.value} value={v.value}>{v.label}</option>)}
        </select>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <label htmlFor={`${idPrefix}-sub-issue-type`} style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", display: "block" }}>
          Sub-issue type <span style={{ fontWeight: 400, color: "var(--text3)" }}>(optional)</span>
        </label>
        <select id={`${idPrefix}-sub-issue-type`} className="inp" aria-label="Sub-issue type" value={subIssueType ?? ""} style={selectStyle}
                disabled={!!disabled || !picklists || issueType === "" || issueType == null}
                title={issueType === "" || issueType == null ? "Choose an issue type first" : undefined}
                onChange={(e) => onChange({ issueType, subIssueType: e.target.value })}>
          <option value="">{issueType === "" || issueType == null ? "Choose an issue type first" : "— None —"}</option>
          {subOptions.map((v) => <option key={v.value} value={v.value}>{v.label}</option>)}
        </select>
      </div>
    </div>
  );
}
